export default function logicsListActions(logic) {
    return dispatch => {
        dispatch({
            type:'GET_LOGICS_LIST',
            payload:logic
        });
    }
}
